import {
  populatedCampaignSchema,
  type PopulatedCampaign,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import * as z from "zod/v4";

export const getCampaignById = {
  name: "getCampaignById" as const,
  input: z.object({
    id: z.string(),
    includeCustomerGroups: z.boolean().optional(),
  }),
  output: populatedCampaignSchema as z.ZodType<PopulatedCampaign>, // TODO (Josh) remove cast when Zod is fixed
};
